import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const SELECTOR =
    '[data-map-suggestion-preview]';

function parseCoordinate(value) {
    const parsed =
        Number.parseFloat(value);

    return Number.isFinite(parsed)
        ? parsed
        : null;
}

function initializePreview(preview) {
    if (
        preview.dataset
            .mapSuggestionPreviewReady
        === 'true'
    ) {
        return;
    }

    const canvas =
        preview.querySelector(
            '[data-map-suggestion-preview-canvas]'
        );

    const latitude =
        parseCoordinate(
            preview.dataset
                .suggestionLatitude
        );

    const longitude =
        parseCoordinate(
            preview.dataset
                .suggestionLongitude
        );

    if (
        !canvas
        || latitude === null
        || longitude === null
    ) {
        return;
    }

    preview.dataset
        .mapSuggestionPreviewReady =
            'true';

    const map = L.map(
        canvas,
        {
            zoomControl: true,
            scrollWheelZoom: false,
            dragging: true,
        }
    ).setView(
        [latitude, longitude],
        17
    );

    L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
            maxZoom: 20,
            attribution:
                '&copy; OpenStreetMap contributors',
        }
    ).addTo(map);

    const suggestedLocationIcon =
        L.divIcon({
            className:
                'festfriends-suggested-location-marker',
            html: `
                <div
                    style="
                        width:28px;
                        height:28px;
                        border-radius:9999px;
                        border:3px solid white;
                        background:#0891b2;
                        box-shadow:
                            0 2px 8px rgba(0,0,0,.35),
                            0 0 0 2px #0e7490;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                    "
                >
                    <div
                        style="
                            width:8px;
                            height:8px;
                            border-radius:9999px;
                            background:white;
                        "
                    ></div>
                </div>
            `,
            iconSize: [28, 28],
            iconAnchor: [14, 14],
            popupAnchor: [0, -16],
        });

    const marker = L.marker(
        [latitude, longitude],
        {
            icon: suggestedLocationIcon,
        }
    ).addTo(map);

    const label =
        preview.dataset
            .suggestionLabel
        || 'Suggested location';

    marker.bindPopup(label);

    const venueLatitude =
        parseCoordinate(
            preview.dataset
                .venueLatitude
        );

    const venueLongitude =
        parseCoordinate(
            preview.dataset
                .venueLongitude
        );

    if (
        venueLatitude !== null
        && venueLongitude !== null
    ) {
        const venuePoint =
            L.latLng(
                venueLatitude,
                venueLongitude
            );

        const suggestionPoint =
            L.latLng(
                latitude,
                longitude
            );

        const distance =
            venuePoint.distanceTo(
                suggestionPoint
            );

        if (distance > 250) {
            L.circleMarker(
                [
                    venueLatitude,
                    venueLongitude,
                ],
                {
                    radius: 7,
                    color: '#52525b',
                    weight: 2,
                    fillColor: '#ffffff',
                    fillOpacity: 1,
                }
            )
                .addTo(map)
                .bindTooltip(
                    'Venue reference point'
                );

            const bounds =
                L.latLngBounds([
                    venuePoint,
                    suggestionPoint,
                ]);

            map.fitBounds(
                bounds,
                {
                    padding: [40, 40],
                    maxZoom: 17,
                    animate: false,
                }
            );
        }
    }

    window.setTimeout(
        () => map.invalidateSize(),
        100
    );
}

function initializePreviews() {
    document
        .querySelectorAll(SELECTOR)
        .forEach(initializePreview);
}

if (
    document.readyState
    === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializePreviews,
        {
            once: true,
        }
    );
} else {
    initializePreviews();
}

document.addEventListener(
    'livewire:navigated',
    initializePreviews
);
